<template>
  <div class="custom-jewelry-box">
    <div class="top-tab-box">
      <span @click="toList('Rings')">Rings</span>
      <span @click="toList('Pendants')">Pendants</span>
      <span @click="toList('Chains')">Chains</span>
      <span @click="toList('Earrings')">Earrings</span>
      <span @click="toList('Necklaces')">Necklaces</span>
      <span @click="toList('Bracelets')">Bracelets</span>
      <span @click="toList('Anklets')">Anklets</span>
      <span @click="toList('Nose Studs')">Nose Studs</span>
      <span @click="toList('Sets')">Sets</span>
      <span @click="toList('Toe Rings')">Toe Rings</span>
      <span @click="toList('Clearance')">Clearance</span>
    </div>
    <div class="box1">
      <div class="how-lt-works">
        <span>How it works</span>
        <h1>Submit Requirements</h1>
        <h2>· <i>Upload your sketches,images,<br> or CAD files</i></h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M22.0003 35.6253L12.6887 26.3137L9.86026 29.1421L24.0024 43.2843L38.1445 29.1421L35.3161 26.3137L26.0003 35.6295L26.0003 5L22.0003 5L22.0003 35.6253Z"
            fill="#6937E3" />
        </svg>
        <h1>Get Fast Quotation</h1>
        <h2>· <i>Online estimation</i></h2>
        <h2>· <i>Accurate quotation</i></h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M22.0003 35.6253L12.6887 26.3137L9.86026 29.1421L24.0024 43.2843L38.1445 29.1421L35.3161 26.3137L26.0003 35.6295L26.0003 5L22.0003 5L22.0003 35.6253Z"
            fill="#6937E3" />
        </svg>
        <h1>Online Ordering</h1>
        <h2>· <i>Confirm the price and lead time</i></h2>
        <h2>· <i>Pay the deposit online or via TT</i></h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M22.0003 35.6253L12.6887 26.3137L9.86026 29.1421L24.0024 43.2843L38.1445 29.1421L35.3161 26.3137L26.0003 35.6295L26.0003 5L22.0003 5L22.0003 35.6253Z"
            fill="#6937E3" />
        </svg>
        <h1>Online Order Monitoring</h1>
        <h2>· <i>Check the production status online</i></h2>
        <h2>· <i>Watch how your product made online</i></h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M22.0003 35.6253L12.6887 26.3137L9.86026 29.1421L24.0024 43.2843L38.1445 29.1421L35.3161 26.3137L26.0003 35.6295L26.0003 5L22.0003 5L22.0003 35.6253Z"
            fill="#6937E3" />
        </svg>
        <h1>On Time Shipping</h1>
        <h2>· <i>Pay the balance online or via TT</i></h2>
        <h2>· <i>Watch the packaging and shipping process online</i></h2>
      </div>
    </div>
    <span class="title">Customer’s Product Information Is Our Top Secret.</span>
    <img class="img-box" src="https://xhdata.wan4.com/wsw-pc-144.png?imageView2/1/w/686/h/322">
    <div class="hint-box">
      .<i>Customize with drawings, pictures, or hand sketches.</i>
    </div>
    <div class="hint-box">
      .<i>Using the “standardized jewelry customizing system”
        ensures efficient communication, accurate quotation, and
        controllable production.</i>
    </div>
    <span class="btn">Coming Soon...</span>
    <div class="bottom-box">
      <div class="bottom-hint">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path
              d="M31.875 17C31.875 8.78477 25.2152 2.125 17 2.125C8.78477 2.125 2.125 8.78476 2.125 17C2.125 25.2152 8.78476 31.875 17 31.875C25.2152 31.875 31.875 25.2152 31.875 17ZM18.0625 8.50064V20.1875H15.9375V8.50064H18.0625ZM15.7129 23.375H18.2629V25.925H15.7129V23.375Z"
              fill="#FF7D00" />
          </svg>
          <span>
            正在预览“克隆后的外贸网站”，内容仅供参考，非上线效果！
          </span>
        </div>
        <div>
          <span>去克隆我的外贸网站</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path
              d="M13.7288 26.4768L11.7754 24.5234L19.2987 17.0001L11.7754 9.47681L13.7288 7.52342L23.2055 17.0001L13.7288 26.4768Z"
              fill="#FF7D00" />
          </svg>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'CustomJewelry',
  components: {
  },
  props: {},
  data() {
    return {

    }
  },

  created() {
  },
  methods: {
    toList(tag) {
      this.$router.push('/maker/earrings?tag='+tag)
    }
  }
}
</script>
<style lang="less" scoped>
.custom-jewelry-box {
  display: flex;
  flex-direction: column;
  padding-bottom: calc(96px + env(safe-area-inset-bottom));
  

  .top-tab-box {
    display: flex;
    height: 78px;
    align-items: center;
    padding: 0 24px;
    overflow-x: scroll;
    background: #fff;
    scrollbar-width: none;
    /* 对于 Firefox 隐藏滚动条 */

    &::-webkit-scrollbar {
      display: none;
      /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
    }

    >span {
      color: #333;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 38px;
      margin-right: 34px;
      white-space: nowrap;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .box1 {
    width: 750px;
    background-color: #fff;
    background-image: url('https://xhdata.wan4.com/wsw-h5-64.png');
    background-repeat: no-repeat;
    background-position: top left;
    background-size: 100% 340px;
    display: flex;
    align-items: center;

    .how-lt-works {
      border-radius: 8px;
      background: #FFF;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.18);
      margin: 240px 24px 32px;
      width: calc(100% - 48px);
      display: flex;
      flex-direction: column;
      padding-bottom: 38px;

      >span {
        color: #702FBC;
        text-align: center;
        font-size: 24px;
        font-style: normal;
        font-weight: bold;
        text-transform: capitalize;
        height: 46px;
        border-radius: 4px;
        background: #F1E4FF;
        display: flex;
        align-items: center;
        padding: 8px;
        margin: 10px auto 40px 10px;
      }

      >h1 {
        margin: 0 0 8px 38px;
      }

      >h2 {
        color: #666;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px;
        margin: 0 0 0 38px;
        display: flex;

        >i {
          margin-left: 10px;
        }
      }

      >svg {
        width: 48px;
        height: 48px;
        margin: 15px 38px;
      }
    }
  }

  .title {
    color: #1D2A59;
    text-align: center;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    text-transform: capitalize;
    margin: 38px 50px 28px;
  }

  .img-box {
    width: 686px;
    height: 322px;
    margin: 0 auto 24px;
  }

  .hint-box {
    margin: 0 auto;
    width: 686px;
    color: #333;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    display: flex;

    >i {
      margin-left: 10px;
    }
  }

  .btn {
    width: 340px;
    height: 76px;
    border-radius: 8px;
    background: #9583AA;
    margin: 28px auto 38px;
    color: rgba(255, 255, 255, 0.90);
    font-size: 28px;
    font-style: normal;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;

  }

  .bottom-box {
    position: fixed;
    bottom: calc(env(safe-area-inset-bottom));
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;

    .bottom-hint {
      background: #FFE4BA;
      display: flex;
      flex-direction: column;
      padding: 12px 26px;

      >div {
        display: flex;
        align-items: center;

        >svg {
          width: 34px;
          height: 34px;
        }

        >span {
          color: #FF7D00;
          font-size: 24px;
          font-style: normal;
          font-weight: 600;
          line-height: 34px;
          margin-left: 10px;
        }
      }

      >div+div {
        justify-content: center;
        margin-top: 4px;

        >span {
          text-decoration-line: underline;
        }
      }
    }
  }

}
</style>